















import Debug from 'debug'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import { EmbedContent, EmbedState, EmbedItem } from './embed-interfaces';

interface Item {
  uri: string;
  size: string;
  aspect: string;
  touched: boolean;
}

const debug = Debug('embed-component')

@Component({
  components: {}
})

export default class EmbedComponent extends Vue
  implements Api.InteractiveComponent<EmbedState, EmbedContent> {

  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;

  @Prop({
    required: true
  })
  public content: EmbedContent;

  @Prop({
    required: true
  })
  public state: EmbedState | null;

  private internalItem: Item = {
    uri: '',
    size: '',
    aspect: '',
    touched: false
  };

  private mounted(): void {
    this.internalItem = {
      uri: this.content.item.uri,
      size: this.content.item.size,
      aspect: this.content.item.aspect,
      touched: this.state?.touched || false
    }
  }

  private calculateSize(size: string) {
    switch (size) {
      case 'small':
        return { width: '60%', left: '20%'}
      case 'medium':
        return { width: '80%', left: '10%'}
      case 'large':
        return { width: '100%', left: '0'}
      default:
      return { width: '100%', left: '0'}
    }
  }

  private calculateAspectRatio(aspect: string, size: string) {

    let ratioNums: number[] = [];
    let isAspectValid: Boolean = true
    aspect.split(":").forEach(num => {
      const newNum = parseInt(num)
      if (newNum) {
        ratioNums.push(Math.abs(parseInt(num)))
      } else {
        isAspectValid = false
      }
    });
    let sizeMultiplier: number = 1
    switch (size) {
      case 'small':
        sizeMultiplier = 0.6
        break
      case 'medium':
        sizeMultiplier = 0.8
        break
      case 'large':
        sizeMultiplier = 1
        break
      default:
        sizeMultiplier = 1
        break
    }

    let ratioPercent: number = 56.25 * sizeMultiplier // default for 16:9 (9 / 16 * 100)

    if (ratioNums.length === 2 && isAspectValid) {
      ratioPercent = ratioNums[1]/ratioNums[0] * 100 * sizeMultiplier
    }

    return { paddingTop: ratioPercent+ '%' }
  }

  private itemTouch() {
    if (!this.internalItem.touched) {
      this.internalItem.touched = true
      this.emitInteractionStateChanged()
      this.emitInteractionResultChanged()
    }
  }

  @Emit('interaction-state-changed')
  public emitInteractionStateChanged() {
    const state = {
      touched: this.internalItem.touched
    }
    debug('emitInteractionStateChanged', state);
    return state
  }

  @Emit('interaction-result-changed')
  public emitInteractionResultChanged() {
    const progress = 1

    const result: Api.Result = {
      progress,
      status: progress < 1 ? 'incomplete': 'completed'
    }
    debug('emitInteractionResultChanged', result);

    return result
  }
}
